import {styled, Typography} from "@mui/material";

const TextTableHeaderOptionText = styled(Typography)`
  font-family: Helvetica, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #06326E;
`;

export default TextTableHeaderOptionText;
